import React from 'react'
import ProdMatrixRow from './ProdMatrixRow'
import FormTitle from '../../../../../library/form/components/FormTitle'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../../library/layout/Index";

const ProdMatrix = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)
    //headerKey="matrixHeader" 
    //console.log("Matrix data ProdMatrix", viewData);
    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <FormTitle formObject={formObject} value='Matrix Chart' />
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} ksc="a" rowKey="" starIcon={"adds"}
                            action={{ actionId: "new", paramName:"addButton", actionParam: {}, refreshMode:"dep", containerKey: "row" }}
                            className="uiActionIconButton" text={<SarasTrans value="Add Matrix" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn200" headerKey="matrixHeader" 
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="matrixHeader" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn200" headerKey="matrixHeader" 
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="matrixHeader" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Quantity" /></li>
                                <li className="uiColumnCenter" style={{ width: '330px' }}><SarasTrans value="BOM" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Action" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData).map((row, index) => (
                                <li><ProdMatrixRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdMatrix, "prodMatrixChart", "prodMatrix")
